import {
  PATIENT_STATUS_ACTIVE,
  PATIENT_STATUS_INACTIVE,
  PATIENT_STATUS_DECEASED,
  PATIENT_STATUS_RECORDED,
} from 'constants/index';

/**
 * Sorts an array of patients by their status in a predefined order:
 * Active → Inactive/Deceased → On Record
 *
 * @param patients - Array of patients to sort
 * @returns Sorted array of patients
 */
export function sortPatientsByStatus(patients: any[]): any[] {
  if (!patients || !Array.isArray(patients)) {
    return [];
  }

  const actives = patients.filter(p => p?.status_id === PATIENT_STATUS_ACTIVE);
  const inactives = patients.filter(p =>
    [PATIENT_STATUS_INACTIVE, PATIENT_STATUS_DECEASED].includes(p?.status_id),
  );
  const onrecord = patients.filter(p => p?.status_id === PATIENT_STATUS_RECORDED);

  return [...actives, ...inactives, ...onrecord];
}
